import { IAction, IActionParameter, IDisplayItem, IEvent } from "@kuika/kuika-cl-model";

export interface ScreenIndex {
  byId: Map<string, string>;
}

interface ScreenListEntry {
  id: string;
  name: string;
}

const MAX_TARGETS = 3;
const TOSCREENID_PARAM = "toScreenId";
const NAVIGATE_LABEL = "NAVIGATE";

export function buildScreenIndex(screenList: ScreenListEntry[] | undefined | null): ScreenIndex {
  const byId = new Map<string, string>();
  if (Array.isArray(screenList)) {
    for (const entry of screenList) {
      if (entry?.id && typeof entry.name === "string" && entry.name.length > 0) {
        byId.set(entry.id, entry.name);
      }
    }
  }
  return { byId };
}

export function collectNavigationTargets(di: IDisplayItem, idx: ScreenIndex): string | null {
  if (!di?.item?.events || idx.byId.size === 0) return null;

  const targets: string[] = [];
  const seen = new Set<string>();

  for (const event of di.item.events as IEvent[]) {
    for (const action of event.actions ?? []) {
      if (!isNavigateAction(action)) continue;
      const targetId = readToScreenIdFixedValue(action);
      if (!targetId) continue;
      const name = idx.byId.get(targetId);
      if (!name || seen.has(name)) continue;
      seen.add(name);
      targets.push(name);
      if (targets.length >= MAX_TARGETS) break;
    }
    if (targets.length >= MAX_TARGETS) break;
  }

  if (targets.length === 0) return null;
  return targets.join(", ");
}

function isNavigateAction(action: IAction): boolean {
  return action?.label === NAVIGATE_LABEL;
}

function readToScreenIdFixedValue(action: IAction): string | null {
  const param = action.parameters?.find((p: IActionParameter) => p.name === TOSCREENID_PARAM);
  const fixedValue = param?.symbol?.fixedValue;
  if (typeof fixedValue !== "string" || fixedValue.length === 0) return null;
  return fixedValue;
}
